"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieLogData = exports.getLastAuthUserCookieByType = exports.getCookiesByType = exports.getLastAuthUserPoolWebClientId = exports.discoverCognitoCookies = void 0;
const core_utility_1 = require("@built/core-utility");
const CognitoCookieNamePrefix = 'CognitoIdentityServiceProvider';
const CognitoUserCookieTypes = [
    // pulled this from actual cookies put on system by cognito
    'accessToken',
    'LastAuthUser',
    'clockDrift',
    'deviceGroupKey',
    'deviceKey',
    'idToken',
    'randomPasswordKey',
    'refreshToken',
    'userData',
];
/** Gets dictionary of all Cognito auth cookies. */
const discoverCognitoCookies = () => {
    const allCookies = core_utility_1.Cookies.getAll();
    const cognitoCookieNames = Object.keys(allCookies).filter((key) => key.startsWith(CognitoCookieNamePrefix));
    const cognitoCookies = cognitoCookieNames.map((name) => ({ name, value: allCookies[name] }));
    return cognitoCookies;
};
exports.discoverCognitoCookies = discoverCognitoCookies;
/** Gets the last auth user's pool web client ID. */
const getLastAuthUserPoolWebClientId = () => {
    const lastUserCookie = (0, exports.getCookiesByType)('LastAuthUser')[0]; // not sure why it can't infer | undefined
    if (!lastUserCookie) {
        return;
    }
    // this cookie name only has three parts namePrefix.userPoolWebClientId.type
    const [_, userPoolWebClientId] = lastUserCookie.name.split('.');
    return userPoolWebClientId;
};
exports.getLastAuthUserPoolWebClientId = getLastAuthUserPoolWebClientId;
/**
 * Gets matching Cognito cookies by type.
 *
 * @param type - type of Cognito cookie to get
 */
const getCookiesByType = (type) => {
    const cookies = (0, exports.discoverCognitoCookies)();
    const nameMatcher = new RegExp(`^${CognitoCookieNamePrefix}\\.\\w+(?:\\.[\\w-]+)?.${type}$`);
    return cookies.filter((c) => nameMatcher.test(c.name));
};
exports.getCookiesByType = getCookiesByType;
/**
 * Gets only the last auth user's matching Cognito cookie for the given type.
 *
 * @param type - type of Cognito cookie to get
 */
const getLastAuthUserCookieByType = (type) => {
    const lastUserPoolWebClientId = (0, exports.getLastAuthUserPoolWebClientId)();
    if (!lastUserPoolWebClientId) {
        return;
    }
    const cookie = (0, exports.getCookiesByType)(type).find((c) => 
    // Cognito drops cookies with its prefix and per user pool web client ID
    c.name.startsWith(`${CognitoCookieNamePrefix}.${lastUserPoolWebClientId}`));
    return cookie;
};
exports.getLastAuthUserCookieByType = getLastAuthUserCookieByType;
// indicates PII or other unnecessary values
const REDACTED_ID_TOKEN_VALUES = [
    'name',
    'given_name',
    'family_name',
    'custom:companyName',
    'picture',
    'token_use', // always id
];
const REDACTED_MATCHER = new RegExp(`^(${REDACTED_ID_TOKEN_VALUES.join('|')})$`, 'i');
/**
 * Gets log data for relevant Cognito cookies, and omits PII and other unnecessary values.
 *
 * Intended to be used with `shipError` to send helpful cookie data where available.
 * */
const getCookieLogData = () => {
    const cookies = (0, exports.discoverCognitoCookies)();
    // we are bypassing the amplify API for this because it may have generated the error we are trying to log
    // in theory there can be more than one, so we treat it as an array
    const ids = cookies
        .filter((c) => c.name.endsWith('idToken'))
        .map((c) => c.value)
        .map((token) => {
        try {
            const parsed = (0, core_utility_1.parseJwtPayload)(token);
            if (!parsed) {
                return { failure: 'Could not parse token.', token };
            }
            const cleaned = Object.fromEntries(Object.entries(parsed).filter(([key]) => !REDACTED_MATCHER.test(key)));
            return cleaned;
        }
        catch (ex) {
            return { failure: ex instanceof Error ? ex.message : String(ex), token };
        }
    });
    const cookieLogData = {
        cookies: cookies.map((c) => c.name),
        ids,
    };
    return cookieLogData;
};
exports.getCookieLogData = getCookieLogData;
